import OverlayMenu from 'web/view/components/navbar/overlay-menu/overlay-menu';
export default OverlayMenu;
